import orderBy from 'lodash/orderBy';
import findIndex from 'lodash/findIndex';
import { routerNames } from "../appCommon.constants";
import { trackEventConstant } from "../../plugins/analytics.constant";

export const memberDirectoryPageConstant = {
    label: {
        MY_FAVORITES_TITLE: 'Favorites',
        MEMBER_DIRECTORY_TITLE: 'Member Directory',
        SELECT_CATEGORIES_TITLE: 'Select one or more categories to refine your results',
        SORT_BY: 'Sort by ',
        FIND_LAST_NAME: 'Find members fast by last name',
        EMAIL: "Email",
        PHONE: "Phone",
        CHAT: "Chat",
        NETWORKS: "Networks",
        LIFETIME: "LifeTime",
        NEW: "New",
        DIRECTORY_TEXT_LENGTH: 80,
        MORE_CHAPTERS: "More",
        CLEAR_ALL: 'Clear All',
        NO_RESULT_FOUND: 'Sorry no members found',
        DEFAULT_TYPE_AHEAD_LABEL: 'WHAT ARE YOU INTERESTED TO SEE?',
        DEFAULT_SUB_FILTER_LABEL: 'PLEASE SELECT ONE OR MORE OPTIONS FROM FOLLOWING',
        NO_TYPE_AHEAD_RESULT_FOUND: 'No results found',
        FORMER_MEMBER: "Former Member",
        NO_SOLICIT: 'Please Do Not Solicit',
        MANAGE_CONTACT: 'Manage Contact',
        NETWORK_ROUTE: 'network',
        CHAPTER_ROUTE: 'chapter',
        PHONE_NUMBER_LENGTH: 3,
        SELECT_COUNTRY: 'Select Country',
        SELECT_STATE: 'State/Province/Region',
        SELECT_CITY: 'City',
        ZIP_CODE: 'ZIP/Postal Code',
        PHONE_EXTENSION: ',,',
        VIEW_FULL_MEMBER_DIRECTORY: 'view the full Member Directory',
        MANAGEMENT_ASSOCIATE: 'YPO Management Associate',
        EDIT_PROFILE: 'Edit Profile',
        ADVANCED_SETTINGS: 'Advanced Settings',
        ALL: 'ALL',
        ERROR_DOWNLOADING_CONTACT: "Error downloading contact.",
        CHAPTER_ADMIN: 'Chapter Administrator',
        CHAPTER_MANAGER: 'Chapter Manager',
        ADVANCED_SEARCH: 'Try Advanced Member Search',
        MEMBERDIRECTORY: 'memberdirectory',
    },
    constant: {
        memberLocationKey: 'memberLocation',
        maxIndexForRibbonFilter: 9,
        chapterAndRegionsKey: 'chapterAndRegions',
        formerMember: 'Former Members',
        memberType: 'memberType',
        memberSearchBox: 'memberSearchBox',
        orderByTypeDefault: 'LastName',
        orderByDefault: 'asc',
        searchResultOffsetStep: 50,
        searchResultMaxCount: 50,
        networks: 'Networks',
        groups: 'Groups',
        combinedCountryStateCityKey: 'CombinedCountryStateCity',
        combinedCountryStateKey: 'CombinedCountryState',
        minimumCountForLastNameSelector: 10,
        companyNameSort: 'CompanyName',
        membervtrackarray: [
            trackEventConstant.COMPONENT.MEMBER_DIRECTORY_SEARCH_PAGE, 
            trackEventConstant.ENTITY.ROLODEX,
            trackEventConstant.ACTION.FILTER_MEMBERS_BY_LETTER,
        ],
        connectionpagevtrackarray: [
            trackEventConstant.COMPONENT.MY_CONNECTIONS_PAGE,
            trackEventConstant.ENTITY.ROLODEX,
            trackEventConstant.ACTION.FILTER_CONNECTIONS_BY_LETTER,
        ],
        selectedOneClickChapter: 'selectedOneClickChapter',
        searchRibbonKeys: {
            memberType: 'memberType',
            memberLocation: 'memberLocation',
            companyDetails: 'companyDetails',
            chapterAndRegions: 'chapterAndRegions',
            networkAndGroups: 'networkAndGroups',
            businessExpertise: 'businessExpertise',
            businessInterests: 'businessInterests',
            personalInterests: 'personalInterests',
            championPositions: 'championPositions',
            companyInvestments: 'companyInvestments',
            memberIndustries: 'memberIndustries',
            connections: 'connections',
            education: 'education',
        },
    },
    SEARCH_RESULTS_OFFSET_STEP: 150,
};

const { searchRibbonKeys } = memberDirectoryPageConstant.constant;
export const ribbonTitles = [
    { key: searchRibbonKeys.memberType, value: 'WHICH TYPES OF MEMBERS DO YOU WANT TO SEE?' },
    { key: searchRibbonKeys.memberLocation, value: 'ARE YOU LOOKING FOR MEMBERS IN A SPECIFIC LOCATION?' },
    { key: searchRibbonKeys.companyDetails, value: 'WHICH COMPANY AND/OR COMPANY ATTRIBUTES DO YOU WANT TO SEE?' },
    { key: searchRibbonKeys.chapterAndRegions, value: 'ARE YOU LOOKING FOR MEMBERS IN SPECIFIC CHAPTERS OR REGIONS?' },
    { key: searchRibbonKeys.networkAndGroups, value: 'ARE YOU LOOKING FOR MEMBERS IN SPECIFIC NETWORKS OR GROUPS?' },
    { key: searchRibbonKeys.businessExpertise, value: 'FIND EXPERTS IN VARIOUS BUSINESS CATEGORIES. CHOOSE FROM THE LIST BELOW TO GET STARTED' },
    { key: searchRibbonKeys.businessInterests, value: 'FIND MEMBERS INTERESTED IN LEARNING MORE ABOUT SPECIFIC BUSINESS TOPICS. CHOOSE FROM THE LIST BELOW TO GET STARTED' },
    { key: searchRibbonKeys.personalInterests, value: 'FIND MEMBERS WITH A VARIETY OF PERSONAL AND FAMILY INTERESTS. CHOOSE FROM THE LIST BELOW TO GET STARTED' },
    { key: searchRibbonKeys.championPositions, value: 'FIND MEMBERS IN CURRENT OR FORMER YPO CHAMPION POSITIONS. CHOOSE COMMUNITY TYPES TO GET STARTED' },
    { key: searchRibbonKeys.companyInvestments, value: 'FIND MEMBERS INVESTED IN SPECIFIC COMPANIES OR INDUSTRIES?' },
    { key: searchRibbonKeys.memberIndustries, value: 'CHOOSE FROM THE LIST TO FIND MEMBERS WITH EXPERIENCE IN PARTICULAR INDUSTRIES' },
    { key: searchRibbonKeys.connections, value: 'FIND YOUR MEMBER FAVORITES' },
    { key: searchRibbonKeys.education, value: 'ARE YOU LOOKING FOR GRADUATES FROM A SPECIFIC COLLEGE OR UNIVERSITY?' },
];

export const typeAheadForMemberDirectory = [
    {
        key: 'Companies',
        label: 'FIND A COMPANY BY NAME',
        placeHolder: 'Enter company name',
    },
    {
        key: 'BusinessTitle',
        label: 'SEARCH FOR SPECIFIC BUSINESS TITLES',
        placeHolder: 'Enter business title',
    },
    {
        key: 'CompanyInvestments',
        label: 'FIND A COMPANY BY NAME',
        placeHolder: 'Enter company name',
    },
    {
        key: 'Position',
        label: 'SEARCH FOR SPECIFIC TITLES',
    },
    {
        key: 'Chapters',
        label: 'SEARCH FOR A SPECIFIC CHAPTER',
        placeHolder: 'Find Chapters by name',
    },
    {
        key: 'Regions',
        label: 'SEARCH FOR A SPECIFIC REGION',
        placeHolder: 'Find Regions by name',
    },
    {
        key: 'Networks',
        label: 'SEARCH FOR A SPECIFIC NETWORK',
        placeHolder: 'Find Networks by name',
    },
    {
        key: 'Groups',
        label: 'SEARCH FOR A SPECIFIC GROUP',
        placeHolder: 'Find Groups by name',
    },
    {
        key: 'SchoolName',
        label: '',
        placeHolder: 'Find a high school, prep school, college or university',
    },
    {
        key: 'CombinedCountryStateCity',
        label: '',
        placeHolder: '',
        inputLabel: 'City',
    },
];

export const subFiltersForRibbon = [
    {
        key: 'ScopesOfBusiness',
        label: 'PLEASE SELECT ONE OR MORE OPTIONS FROM FOLLOWING',
    },
    {
        key: 'OrganizationTypes',
        label: 'PLEASE SELECT ONE OR MORE OPTIONS FROM FOLLOWING',
    },
    {
        key: 'BusinessExpertise',
        label: 'NOW SPECIFY THE TYPES OF EXPERTISE YOU WANT TO SEE',
    },
    {
        key: 'BusinessInterests',
        label: 'NOW SPECIFY THE TYPES OF BUSINESS INTERESTS YOU WANT TO SEE',
    },
    {
        key: 'PersonalInterests',
        label: 'NOW SELECT SPECIFIC PERSONAL AND FAMILY INTERESTS',
    },
    {
        key: 'CurrentGenericChampionPositions',
        label: 'NOW SELECT ONE OR MORE CHAMPION POSITIONS',
    },
    {
        key: 'InvestmentIndustries',
        label: 'CHOOSE FROM THE LIST BELOW TO FIND MEMBERS INVESTED IN COMPANIES FROM PARTICULAR INDUSTRIES',
    },
    {
        key: 'Industries',
        label: 'NOW SELECT SPECIFIC INDUSTRIES YOU WANT TO SEE',
    },
];

export const thirdLayerFilerOptions = [
    {
        key: 'InvestmentIndustries',
        label: 'SELECT SPECIFIC INDUSTRIES YOU WANT TO SEE (OPTIONAL)',
    },
];

export const pillWithType = [
    {
        key: 'Chapters',
        label: 'Chapter | ',
    },
    {
        key: 'Regions',
        label: 'Region | ',
    },
    {
        key: 'Networks',
        label: 'Network | ',
    },
    {
        key: 'Groups',
        label: 'Group | ',
    },
];

export const createTypeAheadFilters = (filterList) => {
    const result = [];
    if (filterList && filterList.length) {
        filterList.forEach((filterItem) => {
           if (filterItem && filterItem.filters && filterItem.filters.length > 0) {
              filterItem.filters.forEach((filter) => {
                  if (filter && filter.isTypeAhead) {
                      const selectedTypeAhead = typeAheadForMemberDirectory.find(item => item.key.toLowerCase() === filter.filterKey.toLowerCase());
                        result.push({
                            key: filter.filterKey,
                            label: selectedTypeAhead ? selectedTypeAhead.label : memberDirectoryPageConstant.label.DEFAULT_TYPE_AHEAD_LABEL,
                            placeHolder: selectedTypeAhead && selectedTypeAhead.placeHolder ? selectedTypeAhead.placeHolder : '',
                            isActive: false,
                            searchText: '',
                            searchResult: null,
                            previouslySelected: null,
                            ribbonGroupName: filter.ribbonGroupName,
                        });
                  }
              });
           }
        });
    }
    return result;
};

export const createSubFilters = (filterList) => {
    const result = [];
    if (filterList && filterList.length) {
        filterList.forEach((filterItem) => {
            if (filterItem && filterItem.filters && filterItem.filters.length > 0) {
                filterItem.filters.forEach((filter) => {
                    if (filter && !filter.isTypeAhead && filter.subFilters && filter.subFilters.length > 0) {
                        const selectedSubFilter = subFiltersForRibbon.find(item => item.key.toLowerCase() === filter.filterKey.toLowerCase());
                        result.push({
                            key: filter.filterKey,
                            value: filter.filterValue,
                            label: selectedSubFilter && selectedSubFilter.label ? selectedSubFilter.label : memberDirectoryPageConstant.label.DEFAULT_SUB_FILTER_LABEL,
                            isActive: false,
                        });
                    }
                });
            }
        });
    }
    return result;
};

export const englishLetters = 
    ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'];

export const createSortableLastNameList = () => {
    return englishLetters.map((letter) => {
       return {
           key: letter,
           disabled: true,
       };
    });
};

export const getLettersBasedOnLastName = (filters) => {
   const result = [...createSortableLastNameList()];
   if (filters) {
      result.forEach((item, index) => {
          const letterFromFilters = filters.find(filter => filter.filterValue.toLowerCase() === item.key.toLowerCase());
          item.disabled = !letterFromFilters;
          if (letterFromFilters) {
              result[index] = {
                  ...item,
                  ...letterFromFilters,
              };
          }
      });
   }
   return result;
};

//This defines the order of display for Filter ribbon
const memberDirectoryRibbonOrder = [
    searchRibbonKeys.chapterAndRegions,
    searchRibbonKeys.networkAndGroups,
    searchRibbonKeys.connections,
    searchRibbonKeys.memberType,
    searchRibbonKeys.memberLocation,
    searchRibbonKeys.companyDetails,
    searchRibbonKeys.memberIndustries,
    searchRibbonKeys.championPositions,
    searchRibbonKeys.businessExpertise,
    searchRibbonKeys.businessInterests,
    searchRibbonKeys.personalInterests,
    searchRibbonKeys.education,
    searchRibbonKeys.companyInvestments,
];

export const rearrangedSearchRibbonGroup = (searchRibbonGroup) => {
    searchRibbonGroup.forEach((ribbon) => {
        const ribbonIndex = findIndex(memberDirectoryRibbonOrder, e => e === ribbon.key, 0);
        if (ribbonIndex >= 0) {
            ribbon.order = ribbonIndex + 1;
        }
    });
    return orderBy(searchRibbonGroup, ['order']);
};

export const createRibbonList = (listOfRibbon, searchResult) => {
    const isFilterEnabled = (filterItem) => {
        let enabled = false;
        if (filterItem && filterItem.length) {
            filterItem.forEach((item) => {
                if (searchResult && searchResult.length) {
                    const pillFound = pillWithType.find(i => i.key === item.filterKey);
                    if (pillFound && item && item.count > 0) {
                        enabled = true;
                    } else if (item && !pillFound && (item.count > 0 || item.isTypeAhead || (item.subFilters && item.subFilters.length > 0))) {
                        enabled = true;
                    }
                }
            });
        }
        return enabled;
    };

    if (listOfRibbon && listOfRibbon.length > 0) {
        listOfRibbon = rearrangedSearchRibbonGroup(listOfRibbon);
        listOfRibbon.forEach((item) => {
            item.enabled = isFilterEnabled(item.filters);
            item.active = false;

            if (item.filters.length > 0) {
               item.filters.forEach((facet) => {
                   facet.label = facet.label ? facet.label : facet.filterValue;
               });
            }
        });
    }

    return listOfRibbon;
};

export const createRibbonState = (listOfRibbon) => {
    const state = {};
    if (listOfRibbon && listOfRibbon.length > 0) {
        listOfRibbon.forEach((item) => {
            state[item.key] = [];
        });
    }
    return state;
};

export const sortOptions = [
    {
        label: 'First Name',
        key: 'firstName_asc',
        sortField: 'FirstName',
        direction: 'asc',
    },
    {
        label: 'Last Name',
        key: 'lastName_asc',
        sortField: 'LastName',
        direction: 'asc',
    },
    {
        label: 'Company Name',
        key: 'companyName_asc',
        sortField: 'CompanyName',
        direction: 'asc',
    },
];

export const memberConnectionTabs = [
    {
        label: 'My Favorites',
        filterKey: 'ConnectionOf',
        key: 'connectionOf',
        active: true,
        noResultMessage: 'You do not have any favorites',
        toolTip: 'Members I’ve added to My Favorites',
    },
];

export const defaultSort = sortOptions[1];

export const isButtonEnabled = (filterKey, ribbonState, selectedFilters) => {
    let noData = true;

    const rs = Object.keys(ribbonState).find(key => key === filterKey);
    const itemFromRs = ribbonState[rs];

    const sf = Object.keys(selectedFilters).find(key => key === filterKey);
    const itemFromSf = selectedFilters[sf];

    if (itemFromRs && itemFromSf && itemFromRs.length !== itemFromSf.length) {
        noData = false;
    }

    if (itemFromRs && itemFromSf && itemFromRs.length && itemFromSf.length) {
        itemFromRs.forEach((rsItem) => {
            const commonItem = itemFromSf.find(sfItem => (sfItem.label === rsItem.label && sfItem.filterKey === rsItem.filterKey));
            if (!commonItem) {
                noData = false;
            }
        });
    }
    return noData;
};

export const sortListAlphabeticallyAsc = (list) => {
   return list && list.length > 0 ? orderBy(list, ['label'], ['asc']) : [];
};

export const filterRibbonListByOrder = (ribbonList) => {
    if (ribbonList && ribbonList.length) {
        ribbonList.forEach((item) => {
            if (item && item.key !== memberDirectoryPageConstant.constant.memberType &&
                item.key !== memberDirectoryPageConstant.constant.networkAndGroupsKey &&
                item.key !== memberDirectoryPageConstant.constant.searchRibbonKeys.connections &&
                item.filters && item.filters.length > 0 ) {
               item.filters = orderBy(item.filters, ['label'], ['asc']);
            }
        });
    }
    return ribbonList;
};

export const getNoResultStatement = (searchText, searchFilters, searchPage, pageType) => {
    const selectedFilterList = [];
    if (searchFilters) {
        Object.keys(searchFilters).forEach((key) => {
            if (searchFilters.hasOwnProperty(key) && searchFilters[key].length) {
                selectedFilterList.push(...searchFilters[key]);
            }
        });
    }
    const result = {
        labelA: '',
        labelB: '',
        labelC: '',
    };

    let searchType = 'members';
    if (searchPage && searchPage === routerNames.EVENT_DIRECTORY_PAGE) {
        searchType = 'events';
    }
    if (searchPage && searchPage === routerNames.COMMUNITY_DIRECTORY_PAGE) {
        searchType = 'communities';
    }
    if (searchPage && searchPage === routerNames.CONTENT_DIRECTORY_PAGE) {
        searchType = 'content';
    }

    if (searchPage && searchPage === routerNames.MEMBER_DIRECTORY_PAGE
        && searchText && searchText.length > 0
        && selectedFilterList && !selectedFilterList.length) {
        result.labelA = `Is "${searchText}" spelled correctly?`;
        result.labelB = `Find people by first name, last name, company name, network, chapter name, champion position, industry 
        and business title.`;
        result.labelC = ` Please try again or `;
    }

    if (searchPage && searchPage === routerNames.CONTENT_DIRECTORY_PAGE
        && searchText && searchText.length > 0
        && selectedFilterList && !selectedFilterList.length) {
        result.labelA = `Is "${searchText}" spelled correctly?`;
        result.labelB = `Find your communities’ files and media, activity from your newsfeeds plus articles from CEO Insights,
        the Source and YPO resources.`;
        result.labelC = ` Please try again or `;
    }

    if (searchPage && searchPage === routerNames.COMMUNITY_DIRECTORY_PAGE
        && searchText && searchText.length > 0
        && selectedFilterList && !selectedFilterList.length) {
        result.labelA = `Is "${searchText}" spelled correctly?`;
        result.labelB = `Search for names of YPO chapters, networks, regions and groups.`;
        result.labelC = ` Please try again or `;
    }

    if (searchPage && searchPage === routerNames.EVENT_DIRECTORY_PAGE
        && searchText && searchText.length > 0
        && selectedFilterList && !selectedFilterList.length) {
        result.labelA = `Is "${searchText}" spelled correctly?`;
        result.labelB = `Search for events using the event name or location.`;
        result.labelC = ` Please try again or `;
    }

    if ((!searchText || searchText.length < 1) && selectedFilterList && selectedFilterList.length) {
        searchType = 'members';
        if (searchPage && searchPage === routerNames.EVENT_DIRECTORY_PAGE) {
            searchType = 'events';
        }
        if (searchPage && searchPage === routerNames.COMMUNITY_DIRECTORY_PAGE) {
            searchType = 'communities';
        }
        if (searchPage && searchPage === routerNames.CONTENT_DIRECTORY_PAGE) {
            searchType = 'content';
        }
        result.labelA = 'That may be a bit too specific.';
        result.labelB = `To see more ${searchType}, please remove some of the filters applied.`;
        result.labelC = null;
    }

    if (searchText && searchText.length > 0 && selectedFilterList && selectedFilterList.length) {
        result.labelA = `Apologies. We could not find any matching ${searchType}.`;
        result.labelB = 'Please check your spelling and try again, or if you are refining an existing search, please try removing some of the filters you applied.';
        result.labelC = null;
    }

    if (memberConnectionTabs.length > 0 && searchPage && searchPage === routerNames.MEMBER_CONNECTIONS
        && pageType && pageType.some(item => item.filterKey === memberConnectionTabs[0].filterKey)
        && selectedFilterList && !selectedFilterList.length) {
        result.labelA = 'You currently have no connections.';
        result.labelB = 'Get instant access to the members most important to you. Add connections to chat instantly with YPO Messenger.';
        result.labelC = null;
    }

    return result;
};

export const privateCommunityMessage = (communityData) => {
    let communityType = '';
    if (communityData && communityData.filterKey) {
        // eslint-disable-next-line no-nested-ternary
        communityType = communityData.filterKey.toLowerCase() === memberDirectoryPageConstant.constant.groups.toLowerCase()
            ? 'group'
            : communityData.filterKey.toLowerCase() === memberDirectoryPageConstant.constant.networks.toLowerCase()
                ? 'network'
                : 'community';
    }
    return ` is a private ${communityType}. Please join the ${communityType} to view the full membership directory.`;
};
